import { getNextShowtimeForJourney } from '../../journey/utils/journey-utils';
import { JourneyGroupType } from '../types/journey-group';
export const groupJourneysByMonthAndYear = (journeys, sortFn) => {
    const groupedJourneyIds = {};
    const groups = [];
    journeys.forEach(journey => {
        const showtime = getNextShowtimeForJourney(journey);
        if (!showtime)
            return;
        const [year, month] = showtime.schedule.startsAt.split(/\-/g);
        if (!groupedJourneyIds[year]) {
            groupedJourneyIds[year] = {};
        }
        if (!groupedJourneyIds[year][month]) {
            groupedJourneyIds[year][month] = [];
        }
        groupedJourneyIds[year][month].push(journey.id);
    });
    Object.keys(groupedJourneyIds).forEach(year => {
        Object.keys(groupedJourneyIds[year]).forEach(month => {
            const journeyIds = groupedJourneyIds[year][month];
            const sortedJourneyIds = sortFn ? journeyIds.sort(sortFn) : journeyIds;
            groups.push({
                id: `${month}/${year}`,
                type: JourneyGroupType.Monthly,
                month: Number(month),
                year: Number(year),
                journeyIds: sortedJourneyIds
            });
        });
    });
    return groups;
};
